"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationListMixin = require("../../mixins/components/PaginationListMixin");
/**
 * Used by the `Pagination` component as a parent for the buttons and readout text.
 *
 * @since 8.0.0
 */
var PaginationList = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "PaginationList",
  componentId: "c11n-8-107-0__sc-1b5xve1-0"
})(["", ""], _PaginationListMixin.PaginationListMixin);
exports.PaginationList = PaginationList;
PaginationList.displayName = 'PaginationList';

/** @component */